import { IMAGE_FILE_TYPES } from 'Common/Constants';

/**
 * @param {String|Number} value
 * @param {Object} options
 * @param {Boolean} options.number
 * @returns {String|Number}
 *
 * @example
 * currency('123') // returns '123.00'
 * currency(12) // returns '12.00'
 * currency(12.12312312312312) // returns '12.12'
 * currency('321.456', { number: true }) // returns 321.45
 */
export const currency = (value = '', options = { number: false }) => {
  if (typeof value === 'number') {
    value = String(value);
  }
  value = value.replace(/[^0-9.]/g, '');
  value = value.replace(/(\..*)\./g, '$1');
  if (isNaN(+value)) {
    value = 0;
  }
  value = (+value).toFixed(2);
  if (options.number) {
    return parseFloat(value);
  }
  return value;
};

/**
 *
 * @param {String|Number} value
 * @returns {String}
 *
 * @example
 * balance(1) // returns '$1.00'
 * balance('.1') // returns '$0.10'
 * balance('-.2') // returns '-$0.20'
 * balance('-1.2') // returns '-$1.20'
 * balance('3.4') // returns '$3.40'
 */
export const balance = value => {
  const isNegative = Number(value) < 0;
  let balanceString = '';
  if (isNegative) {
    balanceString += '-';
  }
  balanceString += '$';
  balanceString += currency(value);
  return balanceString;
};

export const prependBase64 = (value = '', type = IMAGE_FILE_TYPES.JPG) => {
  return `data:${type};base64,${value}`;
};

/**
 * Transforms an array into a normalized object
 * @param {Array<Object>} array
 * @param {String} accessor
 * @returns {Object}
 *
 * @example
 * const arr = [{ Id: 1, Description: 'Site1' }]
 * const map = createMap(arr, 'Id'); // { 1: { Id: 1, Description: 'Site1' }}
 * const map2 = createMap(arr, 'Description'); // { 'Site1': { Id: 1, Description: 'Site1' }}
 * const map3 = createMap(arr, 'Id', 'Description'); // { 1: 'Site1' }
 */
export const createMap = (array, accessor = 'Id', accessor2) =>
  (array || []).reduce((acc, curr) => {
    acc[curr[accessor]] = accessor2 ? curr[accessor2] : curr;
    return acc;
  }, {});

/**
 * Transform an array into key boolean value map
 * @param {Array<any>} array
 * @param {String} accessor
 * @returns {Object}
 *
 * @example
 * const arr = [{ Id: 1, Description: 'Site1' }]
 * createTruthyMap(arr, 'Id'); // { 1: true }
 * const arr2 = ['a', 'b','c'];
 * createTruthyMap(arr2); // { a: true, b: true, c: true }
 */
export const createTruthyMap = (array, accessor = 'Id') =>
  (array || []).reduce((acc, curr) => {
    switch (typeof curr) {
      case 'object':
        acc[curr[accessor]] = true;
        break;
      case 'string':
      case 'number':
      default:
        acc[curr] = true;
        break;
    }
    return acc;
  }, {});



// WEBPACK FOOTER //
// ./src/common/Helpers/format.js